var angular = require('angular');
var _module = angular.module('benoit');

require('./_styles.scss');
require('angular-ui-router');
require('../../filters');
require('../../services/user');
require('../../services/lr-touch');
require('../../services/login-or-register-modal');

_module.requires.push(
    'ui.router'
);

_module.controller('UserMenuCtrl', [
    '$log',
    '$user',
    '$loginOrRegisterModal',
    '$state',

    function UserMenuCtrl($log, $user, $loginOrRegisterModal, $state) {
        $log.debug('UserMenuCtrl', this, $state);

        var vm = this;
        vm.model = {
            user: $user,
            showDropdown: false,
            currentState: $state.current
        };
        vm.events = {
            onSignInClick: login,
            onAccountClick: toggleAccountMenu,
            onLinkClick: changeView
        };

        // Functions
        function login() {
            vm.model.showDropdown = false;
            $loginOrRegisterModal();
        }

        function toggleAccountMenu() {
            vm.model.showDropdown = !vm.model.showDropdown;
        }

        function changeView(viewName) {
            vm.model.showDropdown = false;

            if(viewName) {
                $state.go(viewName);
            }
        }
    }
]);

_module.component('userMenu', {
    controllerAs: 'vm',
    controller: 'UserMenuCtrl',
    template: require('./index.html'),
    bindings: {
        themed: '@' // true or false
    }
});
